//Klaviyo Form Open links in new tab
(function() {
    const observer = new MutationObserver((mutations) => {
      // Look for the Klaviyo form container
      const forms = document.querySelectorAll('.klaviyo-form');
      
      forms.forEach(form => {
        // Find all anchor tags within the form
        const links = form.querySelectorAll('a');
        
        links.forEach(link => {
          // Add target="_blank" if it's not already there
          if (link.getAttribute('target') !== '_blank') {
            link.setAttribute('target', '_blank');
            // Security best practice for opening new tabs
            link.setAttribute('rel', 'noopener noreferrer');
          }
        });
      });
    });

    // Start observing the body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();

  document.addEventListener('DOMContentLoaded', () => {
  // Find all links where the href is exactly "#gewinnspiel"
  const triggerLinks = document.querySelectorAll('a[href="#gewinnspiel"]');

  triggerLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      // Prevent the default jump-to-anchor behavior
      event.preventDefault();

      // Execute the Klaviyo form logic
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'UbwhHR']);
    });
  });
});

//Klaviyo Newsletter Popup
document.addEventListener('DOMContentLoaded', function() {
  
  document.addEventListener('click', function(e) {
    // Check if the clicked element is our newsletter link
    const anchor = e.target.closest('a[href="#newsletter"]');
    
    if (anchor) {
      e.preventDefault();

      // Initialize the Klaviyo onsite object
      window._klOnsite = window._klOnsite || [];

      // Detect language (e.g., 'en' or 'de')
      const currentLang = document.documentElement.lang.split('-')[0].toLowerCase();

      // Trigger the appropriate form based on language
      if (currentLang === 'de') {
        // German Form
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'XzLL2M']);
      } else {
        // English Form (Default fallback)
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'RDc9Cu']);
      }
    }
  });
});

//Product Page Amount Picker discount green (pdp)
document.addEventListener("DOMContentLoaded", function() {
  
  // Configuration: Watch the whole body for added elements
  const observerConfig = { childList: true, subtree: true };
  const targetNode = document.body;

  // 1. Define the Color Function
  function colorBrackets() {
    const labels = document.querySelectorAll('.variant-picker fieldset:last-child label, .variant-picker fieldset:last-child .h-stack span');

    labels.forEach(label => {
      // Check if brackets exist AND if they aren't already colored
      // We check for our specific style to avoid re-doing work
      if (label.innerText.includes('(') && !label.innerHTML.includes('var(--color-green)')) {
        
        label.innerHTML = label.innerHTML.replace(
          /(\([^)]*\))/g, 
          '<span style="color: var(--color-green);">$1</span>'
        );
        
      }
    });
  }

  // 2. Define the Observer
  const observer = new MutationObserver((mutations) => {
    // CRITICAL STEP: Stop watching temporarily!
    // This prevents the script from reacting to its own changes.
    observer.disconnect();

    // Run the coloring logic
    colorBrackets();

    // Start watching again
    observer.observe(targetNode, observerConfig);
  });

  // 3. Initial Run (in case labels are there on load)
  colorBrackets();

  // 4. Start Observing
  observer.observe(targetNode, observerConfig);
});